<template>
  <div
    v-if="user && !user.is_teacher"
    class="mx-1 d-flex justify-content-center align-items-center mt-1 icon-news"
  >
    <router-link :to="{ name: 'news.list' }" @click="clearNotification">
      <i v-if="showNotification" class="fas fa-info-circle"></i>&nbsp;
      <span class="novidades-text text-info mb-0">Novidades</span>
      <i
        class="fas fa-external-link-alt text-info mx-2 mt-1"
        title="Novidades"
      ></i>
    </router-link>
  </div>

  <li class="nav-item m-auto">
    <ul class="list-inline-group year-school-ul">
      <span class="text-secondary year-school">Ano letivo</span
      >&nbsp;
      <li class="list-inline-item">
        <div class="form-group amount-spent-select">
          <select
            v-model="yearStore.selectedYear"
            class="form-control form-control-sm form-select"
            @change="onChangeYear"
          >
            <template
              v-for="(year, index) in yearStore.yearOptions"
              :key="index"
            >
              <option :value="year.id">
                {{ year.text }}
              </option>
            </template>
          </select>
        </div>
      </li>
    </ul>
  </li>

  <!-- Notification -->
  <notification />
  <!-- /Notification -->

  <!-- User Menu -->
  <li class="nav-item dropdown has-arrow">
    <a
      href="javascript:void(0);"
      class="dropdown-toggle nav-link"
      data-bs-toggle="dropdown"
    >
      <span class="font-span text-muted">{{ firstName }} </span>
      <div class="avatar avatar-sm flex-shrink-0 m-l-5">
        <img class="avatar-img rounded-circle" alt="User Image" :src="avatar" />
      </div>
    </a>
    <div class="dropdown-menu">
      <router-link class="dropdown-item" :to="{ name: 'user.profile' }">
        Perfil
      </router-link>
      <router-link class="dropdown-item" @click="logout" to="/">
        Sair
      </router-link>
    </div>
  </li>

  <li
    class="nav-item d-flex justify-content-center align-items-center power-off"
  >
    <router-link to="/" class="nav-link text-danger">
      <i class="fas fa-power-off" style="font-size: 1rem" @click="logout" />
    </router-link>
  </li>

  <!-- /User Menu -->
</template>

<script>
import { useAuthStore } from "@/store/auth";
import Notification from "@/components/notification";
import { useYearStore } from "../store/year";
import { useNotificationNewsStore } from "../store/notificationNews";
import { useNewsStore } from "../modules/news/store/news";
import AvatarMale from "Assets/img/profiles/avatar-male-educasis.png";
import AvatarFemale from "Assets/img/profiles/avatar-female-educasis.png";
import AvatarNeutro from "Assets/img/profiles/avatar-neutro-educasis.png";

export default {
  name: "UserMenu",
  components: {
    Notification
  },
  data: () => ({
    authStore: useAuthStore(),
    yearStore: useYearStore(),
    notificationStore: useNotificationNewsStore(),
    newsStore: useNewsStore(),
    avatars: {
      M: AvatarMale,
      F: AvatarFemale,
      N: AvatarNeutro
    }
  }),
  async mounted() {
    await this.yearStore.getLastYears();
    window.Echo.channel("news").listen("NewsCreated", e => {
      this.notificationStore.setShowNotification(true);
    });
  },
  methods: {
    async logout() {
      await this.authStore.logout();
      this.$router.push({ name: "login" });
    },
    async onChangeYear({ target }) {
      await this.yearStore.setSelectedYear(target.value);
    },
    clearNotification() {
      this.notificationStore.setShowNotification(false);
    }
  },
  computed: {
    user() {
      return this.authStore.user;
    },
    showNotification() {
      return this.notificationStore.showNotification;
    },
    firstName() {
      if (!this.user?.name) return "";
      const firstName = this.user.name.trim().split(" ");

      return (
        firstName[0].charAt(0).toUpperCase() +
        firstName[0].slice(1).toLowerCase()
      );
    },
    avatar() {
      if (!this.user) return this.avatars.N;
      if (this.user.avatar) return this.user.avatar;
      return this.user.sex ? this.avatars[this.user.sex] : this.avatars.N;
    }
  }
};
</script>

<style scoped>
.novidades-text,
i {
  font-size: 15px;
}

@media (max-width: 575px) {
  .font-span {
    display: none !important;
  }
}

@media (max-width: 689px) {
  .novidades-text {
    display: none;
  }

  .icon-news {
    margin-right: 5px !important;
  }

  .user-menu.nav > li > a {
    padding: 0 1px !important;
  }

  .power-off {
    margin: 0 15px !important;
  }
}

.power-off {
  padding: 0 !important;
}
.font-span {
  font-size: 14px !important;
}
</style>
